export default "__VITE_ASSET__CeKSgIov__"